import type { HTMLAttributes } from 'react'
import { cn, formatKopecks, type Kopecks } from '@/shared/lib'

// Сумма из копеек → `₽ 1 200 000`, табличными mono-цифрами (выравнивание в
// колонках/списках). Пустая сумма (проект без указанной суммы) → тире.

interface MoneyAmountProps extends HTMLAttributes<HTMLSpanElement> {
  kopecks: Kopecks | null | undefined
  muted?: boolean
}

export function MoneyAmount({ kopecks, muted = false, className, ...rest }: MoneyAmountProps) {
  const empty = kopecks == null
  return (
    <span className={cn('mono-num', (empty || muted) && 'text-text-tertiary', className)} {...rest}>
      {empty ? '—' : formatKopecks(kopecks)}
    </span>
  )
}
